import styled, { keyframes } from 'styled-components';
import theme from 'theme';

export type PropTypes = {
  imageId: number;
  title?: string;
  subtitle?: string;
  headline?: string;
  buttonLink?: string;
  buttonLabel?: string;
};

export const fadeInFocus = keyframes`
  from {
    opacity: 0;
    filter: blur(5px);
  }
  to {
    opacity: 1;
    filter: unset;
  }
`;

export const ContainerInner = styled.article`
  font-family: 'Source Sans Pro', sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const CmsBannerStyled = styled.figure`
  position: relative;
  padding: 0;
  margin: 0;

  animation: ${fadeInFocus} 0.8s;

  img {
    display: block;
    object-fit: cover;
    width: 100%;
    min-height: 800px;
  }

  a {
    text-underline-position: under;
    font-weight: 600;
  }

  @media ${theme.mediaQuery.tablet} {
    img {
      min-height: 400px;
    }

    a {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.brandGold};
    }
  }

  @media ${theme.mediaQuery.mobile} {
    img {
      min-height: 250px;
    }
  }

  @media ${theme.mediaQuery.desktop} {
    a {
      font-size: 1.1rem;
      color: ${theme.colors.brandBlueDarker};
    }

    ${ContainerInner} {
      padding-bottom: 180px;
    }
  }
`;

export const Caption = styled.figcaption`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  h1 {
    letter-spacing: 10px;
    color: ${({ theme }) => theme.colors.brandBlue};
    font-weight: 600;
    font-size: 3rem;
    margin: 0;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  p {
    color: ${({ theme }) => theme.colors.brandBlue};
    margin: 25px 0;
    width: 60%;
    font-size: 1.3rem;
  }

  @media ${theme.mediaQuery.tablet} {
    position: static;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 20px 0 40px 0;

    h1,
    h2 {
      color: ${({ theme }) => theme.colors.brandGold};
      font-style: normal;
      font-weight: 600;
      font-size: 1.2rem;
      display: inline;
      text-transform: uppercase;
      margin-right: 5px;

      &:after {
        display: none;
      }
    }

    p {
      color: ${({ theme }) => theme.colors.black};
      margin: 25px 0;
      width: unset;
      font-size: 1rem;
    }
  }
`;
